import { render, staticRenderFns } from "./RecurringDepositGoalsDistribution.vue?vue&type=template&id=06b8e334&scoped=true&"
import script from "./RecurringDepositGoalsDistribution.vue?vue&type=script&lang=ts&"
export * from "./RecurringDepositGoalsDistribution.vue?vue&type=script&lang=ts&"
import style0 from "./RecurringDepositGoalsDistribution.vue?vue&type=style&index=0&id=06b8e334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b8e334",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VIcon,VImg,VRow,VTextField})
